import { WarningAmberOutlined } from "@mui/icons-material";
import { Box, Tooltip, Typography, useTheme } from "@mui/material";
import { t } from "i18next";
import {
  CmsAssetPlayability,
  UnplayableReason,
} from "@shared/cmsAssetPlayability";

const REASON_KEYS: Record<UnplayableReason, string> = {
  [UnplayableReason.NO_MEDIA]: "no_media",
  [UnplayableReason.NO_MAIN_MEDIA]: "no_main_media",
  [UnplayableReason.NOT_A_STREAM]: "not_a_stream",
  [UnplayableReason.INVALID_URL]: "invalid_link",
  [UnplayableReason.VIDEO_FILE]: "video_file",
  [UnplayableReason.UPLOAD_STORAGE]: "upload_storage",
  [UnplayableReason.LINK_EXPIRED]: "link_expired",
  [UnplayableReason.ENCRYPTED_WITHOUT_DRM]: "encrypted_without_drm",
  [UnplayableReason.ASSET_NOT_FOUND]: "asset_not_found",
};

const playabilityReasonText = (reason: UnplayableReason): string => {
  const key = REASON_KEYS[reason];
  return key
    ? t(`customerportal.pages.assets.playability.reason.${key}`)
    : reason;
};

const PlayabilityBadge = ({
  playability,
  compact = false,
}: {
  playability?: CmsAssetPlayability;
  compact?: boolean;
}) => {
  const theme = useTheme();

  if (!playability || playability.playable) return null;

  const tooltip = [
    t("customerportal.pages.assets.playability.unplayable_tooltip"),
    ...playability.reasons.map(playabilityReasonText),
  ].join("\n");
  const color = theme.palette.warning.dark;

  return (
    <Tooltip title={<span style={{ whiteSpace: "pre-line" }}>{tooltip}</span>}>
      <Box
        component="span"
        aria-label={tooltip}
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: "0.25rem",
          color,
        }}
      >
        <WarningAmberOutlined
          sx={{ fontSize: compact ? "0.9rem" : "1.1rem" }}
        />
        {!compact && (
          <Typography variant="caption" sx={{ color, lineHeight: 1 }}>
            {t("customerportal.pages.assets.playability.unplayable_label")}
          </Typography>
        )}
      </Box>
    </Tooltip>
  );
};

export default PlayabilityBadge;
